<template>
  <div class="p-4">
    <!-- Menus Module Children (Menus List, Categories, Items and so on.) -->
    <router-view />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'MenusV2',
});
</script>
